/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * CMS-POC WebAPI
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  ProductionMasters,
  ErrorInfo,
  ProductionSearchResult,
  ProductionSearchConditions,
  BinaryFile,
  ProductionDetail,
  PostProductionAdd200,
  ProductionOrderSheets,
  ProductionIsVisual,
  ProductionIsIndex,
  GetProductionInfo200,
  PostProductionOrieditableBody,
  PostProductionOutputOrireplist200,
  PostProductionOutputOrireplistBody
} from '.././model'


/**
 * 制作管理に必要なマスタを一括取得して返す。

 * @summary マスタ一括取得
 */
export const getProductionMasters = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ProductionMasters>> => {
    return axios.get(
      `/productions/masters`,options
    );
  }


export const getGetProductionMastersQueryKey = () => [`/productions/masters`];

    
export type GetProductionMastersQueryResult = NonNullable<Awaited<ReturnType<typeof getProductionMasters>>>
export type GetProductionMastersQueryError = AxiosError<ErrorInfo>

export const useGetProductionMasters = <TData = Awaited<ReturnType<typeof getProductionMasters>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProductionMasters>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProductionMastersQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductionMasters>>> = ({ signal }) => getProductionMasters({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getProductionMasters>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 制作一覧を検索して返す。

 * @summary 制作一覧検索
 */
export const postProductionsSearch = (
    productionSearchConditions: ProductionSearchConditions, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ProductionSearchResult>> => {
    return axios.post(
      `/productions/search`,
      productionSearchConditions,options
    );
  }



    export type PostProductionsSearchMutationResult = NonNullable<Awaited<ReturnType<typeof postProductionsSearch>>>
    export type PostProductionsSearchMutationBody = ProductionSearchConditions
    export type PostProductionsSearchMutationError = AxiosError<ErrorInfo>

    export const usePostProductionsSearch = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProductionsSearch>>, TError,{data: ProductionSearchConditions}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postProductionsSearch>>, {data: ProductionSearchConditions}> = (props) => {
          const {data} = props ?? {};

          return  postProductionsSearch(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postProductionsSearch>>, TError, {data: ProductionSearchConditions}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 制作一覧を検索して、結果をExcel形式でダウンロードする。

 * @summary 制作一覧検索結果ダウンロード
 */
export const postProductionsSearchDownload = (
    productionSearchConditions: ProductionSearchConditions, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.post(
      `/productions/search/download`,
      productionSearchConditions,options
    );
  }



    export type PostProductionsSearchDownloadMutationResult = NonNullable<Awaited<ReturnType<typeof postProductionsSearchDownload>>>
    export type PostProductionsSearchDownloadMutationBody = ProductionSearchConditions
    export type PostProductionsSearchDownloadMutationError = AxiosError<ErrorInfo>

    export const usePostProductionsSearchDownload = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProductionsSearchDownload>>, TError,{data: ProductionSearchConditions}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postProductionsSearchDownload>>, {data: ProductionSearchConditions}> = (props) => {
          const {data} = props ?? {};

          return  postProductionsSearchDownload(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postProductionsSearchDownload>>, TError, {data: ProductionSearchConditions}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 制作管理テーブルから制作管理基本情報、関連テーブルを含めて取得する。

 * @summary 制作管理詳細取得
 */
export const getProductionDetail = (
    productionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ProductionDetail>> => {
    return axios.get(
      `/productions/detail/${productionId}`,options
    );
  }


export const getGetProductionDetailQueryKey = (productionId: number,) => [`/productions/detail/${productionId}`];

    
export type GetProductionDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getProductionDetail>>>
export type GetProductionDetailQueryError = AxiosError<ErrorInfo>

export const useGetProductionDetail = <TData = Awaited<ReturnType<typeof getProductionDetail>>, TError = AxiosError<ErrorInfo>>(
 productionId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProductionDetail>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProductionDetailQueryKey(productionId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductionDetail>>> = ({ signal }) => getProductionDetail(productionId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getProductionDetail>>, TError, TData>(queryKey, queryFn, {enabled: !!(productionId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 制作管理（制作管理表タブ）の編集ロック処理。  
制作管理編集テーブルのレコードに編集対象、編集ロックセッションID、開始日時、有効期限等を設定する。
現在ロックをしているセッションから呼ばれたときは、編集ロックの有効期限を延長する。

 * @summary 制作管理（制作管理表タブ）編集ロック
 */
export const postProductionLock = (
    productionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/productions/lock/${productionId}`,undefined,options
    );
  }



    export type PostProductionLockMutationResult = NonNullable<Awaited<ReturnType<typeof postProductionLock>>>
    
    export type PostProductionLockMutationError = AxiosError<ErrorInfo>

    export const usePostProductionLock = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProductionLock>>, TError,{productionId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postProductionLock>>, {productionId: number}> = (props) => {
          const {productionId} = props ?? {};

          return  postProductionLock(productionId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postProductionLock>>, TError, {productionId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 制作管理（制作管理表タブ）の編集をキャンセルし、編集ロックを解除する。

 * @summary 制作管理（制作管理表タブ）編集キャンセル・ロック解除
 */
export const postProductionCancel = (
    productionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/productions/cancel/${productionId}`,undefined,options
    );
  }



    export type PostProductionCancelMutationResult = NonNullable<Awaited<ReturnType<typeof postProductionCancel>>>
    
    export type PostProductionCancelMutationError = AxiosError<ErrorInfo>

    export const usePostProductionCancel = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProductionCancel>>, TError,{productionId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postProductionCancel>>, {productionId: number}> = (props) => {
          const {productionId} = props ?? {};

          return  postProductionCancel(productionId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postProductionCancel>>, TError, {productionId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 制作管理テーブルの制作管理基本情報・イベント・HS準備項目を更新し、編集ロックを解除する。

 * @summary 制作管理（制作管理表タブ）更新・ロック解除
 */
export const postProductionSave = (
    productionDetail: ProductionDetail, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/productions/save`,
      productionDetail,options
    );
  }



    export type PostProductionSaveMutationResult = NonNullable<Awaited<ReturnType<typeof postProductionSave>>>
    export type PostProductionSaveMutationBody = ProductionDetail
    export type PostProductionSaveMutationError = AxiosError<ErrorInfo>

    export const usePostProductionSave = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProductionSave>>, TError,{data: ProductionDetail}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postProductionSave>>, {data: ProductionDetail}> = (props) => {
          const {data} = props ?? {};

          return  postProductionSave(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postProductionSave>>, TError, {data: ProductionDetail}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 制作管理テーブルに制作管理を追加する。

 * @summary 制作管理追加
 */
export const postProductionAdd = (
    productionDetail: ProductionDetail, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostProductionAdd200>> => {
    return axios.post(
      `/productions/add`,
      productionDetail,options
    );
  }



    export type PostProductionAddMutationResult = NonNullable<Awaited<ReturnType<typeof postProductionAdd>>>
    export type PostProductionAddMutationBody = ProductionDetail
    export type PostProductionAddMutationError = AxiosError<ErrorInfo>

    export const usePostProductionAdd = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProductionAdd>>, TError,{data: ProductionDetail}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postProductionAdd>>, {data: ProductionDetail}> = (props) => {
          const {data} = props ?? {};

          return  postProductionAdd(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postProductionAdd>>, TError, {data: ProductionDetail}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 制作管理の資料区分に応じた発注書一覧を取得する。

 * @summary 制作管理発注書一覧取得
 */
export const postProductionOrderSheets = (
    productionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ProductionOrderSheets>> => {
    return axios.post(
      `/productions/orderSheets/${productionId}`,undefined,options
    );
  }



    export type PostProductionOrderSheetsMutationResult = NonNullable<Awaited<ReturnType<typeof postProductionOrderSheets>>>
    
    export type PostProductionOrderSheetsMutationError = AxiosError<ErrorInfo>

    export const usePostProductionOrderSheets = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProductionOrderSheets>>, TError,{productionId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postProductionOrderSheets>>, {productionId: number}> = (props) => {
          const {productionId} = props ?? {};

          return  postProductionOrderSheets(productionId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postProductionOrderSheets>>, TError, {productionId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 制作管理発注書をダウンロードする。

 * @summary 制作管理発注書ダウンロード
 */
export const postProductionOrderSheetsDownload = (
    productionId: number,
    masterId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.post(
      `/productions/orderSheets/download/${productionId}/${masterId}`,undefined,options
    );
  }



    export type PostProductionOrderSheetsDownloadMutationResult = NonNullable<Awaited<ReturnType<typeof postProductionOrderSheetsDownload>>>
    
    export type PostProductionOrderSheetsDownloadMutationError = AxiosError<ErrorInfo>

    export const usePostProductionOrderSheetsDownload = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProductionOrderSheetsDownload>>, TError,{productionId: number;masterId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postProductionOrderSheetsDownload>>, {productionId: number;masterId: number}> = (props) => {
          const {productionId,masterId} = props ?? {};

          return  postProductionOrderSheetsDownload(productionId,masterId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postProductionOrderSheetsDownload>>, TError, {productionId: number;masterId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 制作管理ビジュアル目次更新

 * @summary 制作管理ビジュアル目次更新
 */
export const postProductionIsvisualUpdate = (
    productionId: number,
    productionIsVisual: ProductionIsVisual, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/productions/isvisual/update/${productionId}`,
      productionIsVisual,options
    );
  }



    export type PostProductionIsvisualUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof postProductionIsvisualUpdate>>>
    export type PostProductionIsvisualUpdateMutationBody = ProductionIsVisual
    export type PostProductionIsvisualUpdateMutationError = AxiosError<ErrorInfo>

    export const usePostProductionIsvisualUpdate = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProductionIsvisualUpdate>>, TError,{productionId: number;data: ProductionIsVisual}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postProductionIsvisualUpdate>>, {productionId: number;data: ProductionIsVisual}> = (props) => {
          const {productionId,data} = props ?? {};

          return  postProductionIsvisualUpdate(productionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postProductionIsvisualUpdate>>, TError, {productionId: number;data: ProductionIsVisual}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 制作管理索引更新

 * @summary 制作管理索引更新
 */
export const postProductionIsindexUpdate = (
    productionId: number,
    productionIsIndex: ProductionIsIndex, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/productions/isindex/update/${productionId}`,
      productionIsIndex,options
    );
  }



    export type PostProductionIsindexUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof postProductionIsindexUpdate>>>
    export type PostProductionIsindexUpdateMutationBody = ProductionIsIndex
    export type PostProductionIsindexUpdateMutationError = AxiosError<ErrorInfo>

    export const usePostProductionIsindexUpdate = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProductionIsindexUpdate>>, TError,{productionId: number;data: ProductionIsIndex}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postProductionIsindexUpdate>>, {productionId: number;data: ProductionIsIndex}> = (props) => {
          const {productionId,data} = props ?? {};

          return  postProductionIsindexUpdate(productionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postProductionIsindexUpdate>>, TError, {productionId: number;data: ProductionIsIndex}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 制作管理情報取得

 * @summary 制作管理情報取得
 */
export const getProductionInfo = (
    productionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetProductionInfo200>> => {
    return axios.get(
      `/productions/${productionId}`,options
    );
  }


export const getGetProductionInfoQueryKey = (productionId: number,) => [`/productions/${productionId}`];

    
export type GetProductionInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getProductionInfo>>>
export type GetProductionInfoQueryError = AxiosError<ErrorInfo>

export const useGetProductionInfo = <TData = Awaited<ReturnType<typeof getProductionInfo>>, TError = AxiosError<ErrorInfo>>(
 productionId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProductionInfo>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProductionInfoQueryKey(productionId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductionInfo>>> = ({ signal }) => getProductionInfo(productionId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getProductionInfo>>, TError, TData>(queryKey, queryFn, {enabled: !!(productionId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 一括チェックイン/チェックアウト（管理者メニュー）

 * @summary 一括チェックイン/チェックアウト（管理者メニュー）
 */
export const postProductionOrieditable = (
    postProductionOrieditableBody: PostProductionOrieditableBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/productions/orieditable`,
      postProductionOrieditableBody,options
    );
  }



    export type PostProductionOrieditableMutationResult = NonNullable<Awaited<ReturnType<typeof postProductionOrieditable>>>
    export type PostProductionOrieditableMutationBody = PostProductionOrieditableBody
    export type PostProductionOrieditableMutationError = AxiosError<ErrorInfo>

    export const usePostProductionOrieditable = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProductionOrieditable>>, TError,{data: PostProductionOrieditableBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postProductionOrieditable>>, {data: PostProductionOrieditableBody}> = (props) => {
          const {data} = props ?? {};

          return  postProductionOrieditable(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postProductionOrieditable>>, TError, {data: PostProductionOrieditableBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 一括置換L2リスト出力（管理者メニュー）

 * @summary 一括置換L2リスト出力（管理者メニュー）
 */
export const postProductionOutputOrireplist = (
    postProductionOutputOrireplistBody: PostProductionOutputOrireplistBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostProductionOutputOrireplist200>> => {
    return axios.post(
      `/productions/outputorireplist`,
      postProductionOutputOrireplistBody,options
    );
  }



    export type PostProductionOutputOrireplistMutationResult = NonNullable<Awaited<ReturnType<typeof postProductionOutputOrireplist>>>
    export type PostProductionOutputOrireplistMutationBody = PostProductionOutputOrireplistBody
    export type PostProductionOutputOrireplistMutationError = AxiosError<ErrorInfo>

    export const usePostProductionOutputOrireplist = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProductionOutputOrireplist>>, TError,{data: PostProductionOutputOrireplistBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postProductionOutputOrireplist>>, {data: PostProductionOutputOrireplistBody}> = (props) => {
          const {data} = props ?? {};

          return  postProductionOutputOrireplist(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postProductionOutputOrireplist>>, TError, {data: PostProductionOutputOrireplistBody}, TContext>(mutationFn, mutationOptions)
    }
    